<template>
    <custom-table
        :title="$t('pages.company.title')"
        :subTitle="$t('pages.company.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        filterComponentName="CompanyFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:name="{ row: record }">
            {{ record.name }}
        </template>
        <template v-slot:company_type="{ row: record }">
            {{ record.company_type_id }}
        </template>
        <template v-slot:tax_office="{ row: record }">
            {{ record.tax_office }}
        </template>
        <template v-slot:tax_number="{ row: record }">
            {{ record.tax_number }}
        </template>
        <template v-slot:active="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <router-link :to="'/company/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                     </span>
                    </router-link>
                </el-tooltip>
                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "company",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.company.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.company.cols.name"),
                    scopedSlots: {customRender: "name"}
                },
                {
                    name: this.$t("pages.company.cols.company_type"),
                    scopedSlots: {customRender: "company_type"}
                },
                {
                    name: this.$t("pages.company.cols.tax_office"),
                    scopedSlots: {customRender: "tax_office"}
                },
                {
                    name: this.$t("pages.company.cols.tax_number"),
                    scopedSlots: {customRender: "tax_number"},
                },
                {
                    name: this.$t("pages.company.cols.active"),
                    scopedSlots: {customRender: "active"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            rules: {},
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    created() {
    },
    computed: {
        table() {
            return this.$store.state.company.table;
        },
        userID() {
            return this.$route.query.userID;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.companyManagement"), []);

        this.filterParameters = {
            id: this.userID,
            sort: 'created_at:desc'
        };

        this.$store.dispatch('company/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    //this.newUser();
                    this.$router.push({
                        path: "/company/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('company/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("company/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("company/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
    }
}
</script>

<style scoped>

</style>